// 请求地址
// const admin_api = 'https://cygs.api.xiaocx.cc/Admin';           // 测试
const admin_api = 'https://api.xcx.vstartup.cn/Admin';          // 正式



// 阿里云-华北区
const upload_url = admin_api + '/ali_oss/index';       // 正式

export default {
    upload_url,
    admin_api,
}



// WEBPACK FOOTER //
// ./src/util/common.js